import React from 'react';
import PropTypes from 'prop-types';
import { useConfigService } from '@thd-nucleus/experience-context';
import { FULFILLMENT_METHODS } from '../../../constants';
import { Skeleton, SkeletonLine } from '@one-thd/sui-atomic-components';

const ShippingThreshold = ({
  type,
  hasFreeShipping,
  totalCharge,
  maxCartPriceContributor,
  selected,
  isCartTiles,
  loading = false
}) => {
  let displayDeliveryFeeValue = useConfigService('fs:displayDeliveryFeeValue');
  // Parse the FS value even if it is set as a string number like "15.50" or "15.5"
  displayDeliveryFeeValue = displayDeliveryFeeValue === undefined
    ? null : parseFloat(displayDeliveryFeeValue).toString();

  const deliveryFeeAttribute = '$' + (totalCharge || 0);
  const showMultiLineDeliveryFee = isCartTiles && maxCartPriceContributor && selected;
  const getMultiLineDeliveryPrice = () => {
    return <span className="sui-font-bold sui-text-succes" data-delivery-fee={deliveryFeeAttribute}>Included</span>;
  };

  const hasFreeShippingCondtions = [
    hasFreeShipping && type === FULFILLMENT_METHODS.APPLIANCE,
    !totalCharge && [FULFILLMENT_METHODS.STH_FFM, FULFILLMENT_METHODS.EXPRESS_DELIVERY].includes(type)
  ];

  if (hasFreeShippingCondtions.some((condition) => !!condition)) {
    return loading ? <SkeletonLine variant="single" numberOfLines={1} /> : <span className="sui-font-bold sui-text-succes" data-delivery-fee={deliveryFeeAttribute}>FREE</span>;
  }

  if ([FULFILLMENT_METHODS.STH_FFM, FULFILLMENT_METHODS.EXPRESS_DELIVERY].includes(type)) {
    if (showMultiLineDeliveryFee) {
      return getMultiLineDeliveryPrice();
    }
  }

  // Display the delivery fee if config value is present and it matches the config value
  const isDisplayDeliveryFeeValue = displayDeliveryFeeValue
    && (displayDeliveryFeeValue === totalCharge?.toString());

  let deliveryFeeElement;
  if (loading) {
    deliveryFeeElement = isDisplayDeliveryFeeValue ? <SkeletonLine variant="single" numberOfLines={1} /> : '';
  } else {
    deliveryFeeElement = isDisplayDeliveryFeeValue ? deliveryFeeAttribute : ' ';
  }

  return (
    <span
      // eslint-disable-next-line @harmony/stencil/no-tailwind-disable
      className={'sui-pt-2 sui-min-h-[24px]' + (isDisplayDeliveryFeeValue ? ' sui-text-primary' : '')}
      data-delivery-fee={deliveryFeeAttribute}
      data-testid="delivery-fee-span"
    >
      { deliveryFeeElement }
    </span>
  );
};

ShippingThreshold.propTypes = {
  type: PropTypes.string,
  hasFreeShipping: PropTypes.bool,
  totalCharge: PropTypes.number,
  maxCartPriceContributor: PropTypes.bool,
  selected: PropTypes.bool,
  isCartTiles: PropTypes.bool,
  loading: PropTypes.bool
};

ShippingThreshold.defaultProps = {
  type: null,
  hasFreeShipping: false,
  totalCharge: null,
  maxCartPriceContributor: false,
  selected: false,
  isCartTiles: false
};

export { ShippingThreshold };